import BaseApi from '../BaseApi';
import { PaykassmaConverter } from './PaykassmaConverter';

class PaykassmaApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);

    this.baseUrl = ``;
    this.converter = new PaykassmaConverter();
  }

  paykassmaDeposit = info => {
    return this.sendQuery(
      this.queryTypes.POST,
      `${this.baseUrl}/paykassma/deposit/init`,
      {
        amount: info.amount,
        return_url: info.returnUrl,
        payment_system: info.paymentSystem,
      },
      {
        headers: {
          'x-partner-name': info.sessionToken.projectName,
          'x-partner-authorization': info.sessionToken.needCook,
        },
      },
    );
  };

  // paykassmaWithdrawal = info => {
  //   return this.sendQuery(
  //     this.queryTypes.POST,
  //     `${this.baseUrl}/paykassma/withdrawal/init`,
  //     { amount: info.amount, phone_number: info.phone_number },
  //     {
  //       headers: {
  //         'x-partner-name': info.sessionToken.projectName,
  //         'x-partner-authorization': info.sessionToken.needCook,
  //       },
  //     },
  //   );
  // };
}

export default PaykassmaApi;
